import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { ClassificaVO } from "./classificaVO";
import { UtenteVO } from "./utenteVO";
import { VisibilitaFascicoloVO } from "./visibilita-fascicoloVO";
import { RiferimentiPosizioneVO } from "./riferimenti-posizioneVO";
import { DocumentoVO } from "./documentoVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";

export class WrapperCollegamentoUnitaDocumentariaVO {
  id: string;

  primario: DocumentoVO;

  tipo: TipoSupportoDocumentoEnum;

  // private TipoDocumentoDTO tipo;

  oggetto: string;

  segnaturaArchivistica: string;

  metadatiRepertorio: MetadatiRepertorioVO;

  dataInserimento: string;

  //  private String numeroDocCartacei;

  riferimentoPosizione: RiferimentiPosizioneVO;

  stato: string;

  classifica: ClassificaVO;

  dataUltimaModifica: string;

  inseritoDa: UtenteVO;

  visibilitaElemento: VisibilitaFascicoloVO[];
}
